import React, { Component } from 'react'

import '../../css/BisharatMain.css';
import NotificationService from '../../services/NotificationService';
import {ENV_URL} from '../../services/Globals';
import noImagejpg from '../../data/images/nothingtoshow.png'
import translate from '../../languages/translate';
export default class Notification extends Component {
    state = {
        oneNotification: []
    }

    componentDidMount() {
        const { match: { params } } = this.props;
        const notifId = params.id;
        NotificationService.getNotification(notifId)
            .then(res => {
                const oneNotification = res.data;
                this.setState({ oneNotification });
            })
    }


    

    render() {
        return (
            <div className="top-level-page-main notif-detail">
                <div className="view-details-notif ">
                    <div className="notif-details">
                        <div className="card-group-field">
                            <h5>  {translate("notif")}    </h5>
                            <h4> {this.state.oneNotification.subject}   </h4>
                        </div>
                        <div>
                        <textarea dir="rtl" readonly className="form-control contentarea"
                            rows="10" cols="50"
                         value={this.state.oneNotification.description}
/>
</div>


                        <div className="card-group-field">
                            <h5>  {translate("publishdate")}     </h5>
                            <h4> {this.state.oneNotification.createdDate}   </h4>
                        </div>

                       
                        <div className="small-for-notif-details img">


                        {this.state.oneNotification.imageLink ? 
                        <img src={`${ENV_URL}/api/v1/notifications/${this.state.oneNotification.id
              }/download`}
              alt="the-notif"/> :
              <img src={noImagejpg} alt="nothing-to-show"/>
            }

                                    </div>
                          <a className="btn" href="/family-notification"> {translate("back")} </a>
                   
               </div>
                </div>
            </div>
        )
    }
}
